import PlusCircle from 'assets/icons/PlusCircle';
import COLOR from 'constants/color';
import { ATTRIB } from 'constants/test';
import { useAppDispatch, useAppSelectorShallow } from 'store/hooks';
import { addNewActivityButtonSelector } from 'store/reducer/setting/selectors';
import { newHabit } from 'store/reducer/setting/slice';
import { getNewHabitProps } from 'utils/helpers';
import Tooltip from 'components/common/Tooltip';
import { t } from 'services/i18n.service';
import { capturePostHogEvent } from 'services/posthog.service';
import { BaseButtonXs } from 'components/ui/BaseButton';

interface Props {
  additionalStyles?: string;
  title?: string;
}

const AddNewActivityButton = ({ title, additionalStyles }: Props) => {
  const dispatch = useAppDispatch();
  const {
    tabs,
    activeTabIndex,
    customRoutine,
    currentSettings,
    routineSuggestionsSelectedRoutines,
    platform
  } = useAppSelectorShallow(addNewActivityButtonSelector);

  const [activity_type, sequence_id] = getNewHabitProps(
    tabs,
    activeTabIndex,
    currentSettings,
    platform,
    customRoutine,
    routineSuggestionsSelectedRoutines
  );

  return (
    <BaseButtonXs
      data-test={ATTRIB.TEST.ICON_ADD_HABIT}
      data-locator={ATTRIB.LOCATOR.ADD_HABIT}
      id={ATTRIB.TEST.ICON_ADD_HABIT}
      onClick={() => {
        dispatch(
          newHabit({
            type: activity_type,
            sequence_id
          })
        );
        capturePostHogEvent('add-new-habit', {
          'routine-type': activity_type
        });
      }}
      className='rounded-full w-fit h-fit dark:bg-gray-600 bg-white'
      variant='secondary'
      icon={
        <Tooltip
          icon={
            <PlusCircle
              styles={`${title ? '~w-3.5/4' : '~w-4/5'} h-auto`}
              fill={COLOR.PRIMARY.LIGHT_900}
            />
          }
          message={t('new_activity')}
        />
      }
      additionalStyles={additionalStyles}
      title={title}
      aria-label={title ?? t('new_activity')}
    />
  );
};

export default AddNewActivityButton;
